export default {
  name: 'image-card',
  type: 'text',
  render() {}
};
